import PortalDialog from './PortalDialog';

export default PortalDialog;



// WEBPACK FOOTER //
// ./src/components/PortalDialog/index.js